'use client';

import * as React from 'react';
import createSvgIcon from '../../utils/createSvgIcon';

/**
 * @ignore - internal component.
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon( /*#__PURE__*/_jsx("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz');


//////////////////
// WEBPACK FOOTER
// ../@mui/material/internal/svg-icons/MoreHoriz.js
// module id = 1724
// module chunks = 22